/**
 * External Dependencies
 */
import 'jquery';

import 'bootstrap';
import './_theme';
import './_scroll-into';
import './slider.js';
import 'ion-rangeslider';
import {DealFilter} from "./deal-filter";
import {ScrollInto} from "./_scroll-into";




$(document).ready(() => {

  let dealFilter = new DealFilter(appVars.dealsURL);
  dealFilter.init();

  let scrollInto = new ScrollInto();
  scrollInto.init();

  $(".js--range-slider").ionRangeSlider({
    max_postfix: '+',
    onFinish: function (data) {
      $('.js--range-slider-from').val(data.from);
      $('.js--range-slider-to').val(data.to);
    },
  });

  $('.ds-woo-select').each( function() {
    var select2_args = $.extend({
      placeholder: $( this ).attr( 'data-placeholder' ) || $( this ).attr( 'placeholder' ) || '',
      width: '100%',
    }, {'language': {
        errorLoading: function() {
         return '';
        },
        inputTooLong: function( args ) {
          return '';
        },
        inputTooShort: function( args ) {


          return '';
        },
        loadingMore: function() {
          return '';
        },
        maximumSelected: function( args ) {

          return '';
        },
        noResults: function() {
          return '';
        },
        searching: function() {
          return '';
        },
      }});

    $( this )
      .on( 'select2:select', function() {
        $( this ).focus(); // Maintain focus after select https://github.com/select2/select2/issues/4384
      } )
      .selectWoo( select2_args );
  });

  $('#videoModal').on('hide.bs.modal', function (e) {
    $(this).find('iframe').each(function(){
      var src = this.getAttribute('src');
      this.setAttribute('src', '');
      this.dataset.src = src;
    });
  })

  $('#videoModal').on('show.bs.modal', function (e) {
    $(this).find('iframe').each(function(){
      if(this.getAttribute('src') === '') {
        this.setAttribute('src', this.dataset.src)
      }
    });
  });

  $('.js--select-with-other').on('change', function(){
    if(this.value.toLowerCase() === 'other') {
      $(this).parent().find('.js--other-option').val('');
      $(this).parent().find('.js--other-option').removeClass('d-none');
    } else {
      $(this).parent().find('.js--other-option').val(this.value);
      $(this).parent().find('.js--other-option').addClass('d-none');
    }

  });

  var ds_checkout_coupons = {
    init: function() {
      $( '.woocommerce a.showcoupon' ).on( 'click', this.show_coupon_form );
    },
    show_coupon_form: function() {
      $( '.checkout_coupon' ).slideToggle( 400, function() {
        $( '.checkout_coupon' ).find( ':input:eq(0)' ).focus();
      });
      return false;
    },
  };

  var ds_checkout_login_form = {
    init: function() {
      $( '.woocommerce a.showlogin' ).on( 'click', this.show_login_form );
    },
    show_login_form: function() {
      $( 'form.login, form.woocommerce-form--login' ).slideToggle();
      return false;
    },
  };

  ds_checkout_coupons.init();
  ds_checkout_login_form.init();

});
